import { FloatingLabelInput, FloatingLabelTextarea } from '../../components.js';
import { EditPage, populateEditForm } from '../crud/shared.js';

export class AuthEdit extends EditPage {
  static get formAction() {
    return API.resourceUrl('authConfigs', Routing.params.id);
  }

  static timl = `
    <Breadcrumbs title="Authentication" href="/auth" nameHref="/auth/{{ Routing.params.id }}" compact="true" nameStyle="" nameSeparatorStyle="" suffix="Edit" suffixStyle="" suffixSeparatorStyle="">

    form.fade.stacked-form[method="PATCH" action="{{ Routing.routeObject.formAction }}" onSuccessRedirect="/auth"]
      <FloatingLabelInput label="Name" name="name">
      <FloatingLabelTextarea label="Domain (optional)" name="domain" required="false">
      .horizontal-flex.mt-15
        <FormButton label="Update">
        a.underline.pointer.ml-auto.red.f12[href="/{{ Routing.getRouteFromPathName() }}/{{ Routing.params.id }}/delete"] Delete
  `;

  static javascript() {
    API.get(API.resourceUrl('authConfigs', Routing.params.id))
      .then(data => {
        populateEditForm(data.data);
        document.querySelector('#name').innerHTML = data.data.name;
        document.querySelector('.fade:not(.in)').classList.add('in');
      });
  }
}
